import { dailyStatus } from '../../services/daily.js';
import type { FeatureManifest } from '../registry.js';

/** SO-02 daily puzzle (SCR-07): available / done today with a countdown / result card. */
export default {
  id: 'daily',
  unlock: 'dailyPuzzle',
  flag: 'dailyPuzzle',
  provides: ['dailyPuzzle', 'dailyResult'],
  entry: { order: 1, icon: 'calendar', label: 'rail.daily', testId: 'rail-daily', open: 'dailyPuzzle', badge: (a) => dailyStatus(a.services.store.state, a.services.now()).kind === 'available' },
  // a friend's daily link (/s/:id resolved by features/links): the same puzzle, side by side
  links: ['daily'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
